import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import {
    UsersRequestDTO,
    UsersResponseDTO,
    UserStatus,
    UserStatusConfirmationRequestDTO,
    UserStatusRegistrationRequestDTO,
    UserStatusResponseDTO
} from 'models'
import {
    AccessLog,
    QueryAccess,
    QueryReport
} from 'pages/ReportManagement/components/Accesses/types'
import api from './api'

const { ENDPOINT_API_USERS } = environments

export const createUser = async (
    data: UsersRequestDTO
): Promise<AxiosResponse<UsersResponseDTO[]>> => {
    return await api.post(`${ENDPOINT_API_USERS}/usuarios`, data)
}

export const editUser = async (
    data: any,
    idUser: any
): Promise<AxiosResponse<UsersResponseDTO[]>> => {
    return await api.put(`${ENDPOINT_API_USERS}/usuarios/${idUser}`, data)
}

export const agreeUser = async (id: string): Promise<AxiosResponse<void>> => {
    return await api.patch(`${ENDPOINT_API_USERS}/usuarios/${id}/aceite`)
}

export const getStatus = async (
    id: string
): Promise<AxiosResponse<void | UserStatusResponseDTO>> => {
    return await api.get(`${ENDPOINT_API_USERS}/usuarios/signup/${id}`)
}

export const postStatus = async ({
    id,
    ...data
}: UserStatusConfirmationRequestDTO): Promise<AxiosResponse<void>> => {
    return await api.post(`${ENDPOINT_API_USERS}/usuarios/signup/${id}`, data)
}

export const patchStatus = async ({
    id,
    ...data
}: UserStatusRegistrationRequestDTO): Promise<AxiosResponse<void>> => {
    return await api.patch(`${ENDPOINT_API_USERS}/usuarios/signup/${id}`, data)
}

export const changeUserStatus = async (
    id: string,
    data: UserStatus
): Promise<AxiosResponse<void>> => {
    return await api.patch(
        `${ENDPOINT_API_USERS}/usuarios/${id}/status`,
        data,
        {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
            }
        }
    )
}

export const getAccessLogs = async (
    query: QueryAccess,
    instituicaoFinanceiraId?: string
): Promise<AxiosResponse<AccessLog[]>> => {
    const params = {
        ...query,
        dataDe: formatDate(query.dataDe),
        dataAte: formatDate(query.dataAte)
    };

    if (instituicaoFinanceiraId) {
        params.instituicaoFinanceira = instituicaoFinanceiraId;
    }

    return api.get(`${ENDPOINT_API_USERS}/usuarios/acessos`, {
        params: params,

        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
        }
    });
}

export const getAccessOnlines = async (
    query: QueryAccess,
    instituicaoFinanceiraId?: string
): Promise<AxiosResponse<AccessLog[]>> => {
    const params = {
        ...query,
        dataDe: formatDate(query.dataDe),
        dataAte: formatDate(query.dataAte)
    };

    if (instituicaoFinanceiraId) {
        params.instituicaoFinanceira = instituicaoFinanceiraId;
    }

    return api.get(`${ENDPOINT_API_USERS}/usuarios/acessos/onlines`, {
        params: params,

        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
        }
    });
}

export const getAccessReportFile = async (
    query: QueryReport,
    instituicaoFinanceiraId?: string
): Promise<AxiosResponse<BlobPart>> => {

    const params = {
        ...query,
        dataDe: formatDate(query.dataDe),
        dataAte: formatDate(query.dataAte)
    };

    if (instituicaoFinanceiraId) {
        params.instituicaoFinanceira = instituicaoFinanceiraId;
    }

    return api.get(`${ENDPOINT_API_USERS}/usuarios/acessos/relatorios`, {
        params: params,

        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
        }
    });
}

const formatDate = (date: Date | string | null | undefined): string | undefined => {
    if (!date) {
        return undefined;
    }
    const d = new Date(date);

    if (isNaN(d.getTime())) {
        return undefined;
    }

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(new Date(d.getTime() + (d.getTimezoneOffset() * 60000)).getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const resendSignupConfirmationCode = async (
    id: string
): Promise<AxiosResponse<void>> => {
    return await api.post(
        `${ENDPOINT_API_USERS}/usuarios/signup/${id}/resend-code`
    )
}

const Users = {
    createUser,
    agreeUser,
    getStatus,
    postStatus,
    patchStatus,
    changeUserStatus,
    getAccessLogs,
    getAccessReportFile,
    resendSignupConfirmationCode
}

export default Users
